import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { SmoothScroll } from '@/components/site/SmoothScroll';
import Landing from '@/pages/Landing';

function App() {
  return (
    <SmoothScroll>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          className:
            'rounded-none border border-foreground bg-foreground text-background font-body',
          duration: 4500,
        }}
      />
    </SmoothScroll>
  );
}

export default App;
